import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createCaptureConstructionProfile, deleteCaptureConstructionProfile, getCaptureConstructionProfiles, updateCaptureConstructionProfile } from "../../api/captures/constructionProfile";
import { ConstructionProfileForm } from "../../types/forms/capture";

export const useCaptureConstructionProfile = (captureIdStr?: string) => {
  const queryClient = useQueryClient();
  const captureId = Number(captureIdStr);

  const queryKey = ["capture", captureId, "construction-profile"];

  const result = useQuery({
    queryKey,
    queryFn: () => getCaptureConstructionProfiles(captureId),
    enabled: !!captureId,
  });

  const createMutation = useMutation({
    mutationFn: (values: ConstructionProfileForm) => createCaptureConstructionProfile(captureId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ profileId, values }: { profileId: number; values: ConstructionProfileForm }) => updateCaptureConstructionProfile(captureId, profileId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const deleteMutation = useMutation({
    mutationFn: (profileId: number) => deleteCaptureConstructionProfile(captureId, profileId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return {
    constructionProfilesData: result.data ?? [],
    isPending: result.isPending,
    isError: result.isError,
    error: result.error,
    createConstructionProfile: createMutation.mutateAsync,
    updateConstructionProfile: updateMutation.mutateAsync,
    deleteConstructionProfile: deleteMutation.mutateAsync,
    isUpdating: createMutation.isPending || updateMutation.isPending || deleteMutation.isPending,
  };
};
